import React, { FC, ReactNode, useLayoutEffect } from 'react';
import {
	IconChevronLeft,
	IconChevronRight,
} from '@montel/montelpro-shared-components-v2';
import { useObserveElementWidth } from './hooks/useObserveElementWidth';
import { StyledSliderButton, StyledSliderWrapper } from './styles';

export interface SliderPropTypes {
	setTrackIsActive: any;
	initSliderWidth: (width: number) => void;
	setActiveItem: any;
	activeItem: number;
	positions: any;
	children: ReactNode;
	gap: number;
}

const Slider: FC<SliderPropTypes> = ({
	setTrackIsActive,
	initSliderWidth,
	setActiveItem,
	activeItem,
	positions,
	children,
	gap,
}) => {
	const { width, ref } = useObserveElementWidth<HTMLDivElement>();

	useLayoutEffect(
		() => initSliderWidth(Math.round(width)),
		[width, initSliderWidth],
	);

	const handleFocus = () => setTrackIsActive(true);

	const handleDecrementClick = () => {
		setTrackIsActive(true);
		if (!(activeItem === positions.length - positions.length)) {
			setActiveItem((prev: number) => prev - 1);
		}
	};

	const handleIncrementClick = () => {
		setTrackIsActive(true);
		if (!(activeItem === positions.length)) {
			setActiveItem((prev: number) => prev + 1);
		}
	};

	return (
		<>
			<StyledSliderButton
				type="button"
				aria-label="Left"
				onClick={handleDecrementClick}
				onFocus={handleFocus}
				$side="left"
				disabled={activeItem === 0 && true}
			>
				<IconChevronLeft color="textDefault" />
			</StyledSliderButton>
			<StyledSliderWrapper ref={ref} className="slider-inner" $gap={gap}>
				{children}
			</StyledSliderWrapper>
			<StyledSliderButton
				type="button"
				aria-label="Right"
				onClick={handleIncrementClick}
				onFocus={handleFocus}
				$side="right"
				disabled={activeItem + 1 === positions.length && true}
			>
				<IconChevronRight color="textDefault" />
			</StyledSliderButton>
		</>
	);
};

export default Slider;
